/**
 * MinusIcon/index.js
 * desc: content minus icon
 * note: action icon via IconButton; defaults its tooltip + accessible name to the
 *       action label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const MinusIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="minus icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.minus.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 14 2" xmlns="http://www.w3.org/2000/svg"><path d="M14 2H0V0h14v2z"/></svg>
    </IconButton>
);


export default MinusIcon;
